export const CONST_TAG_SCOPE_VENDOR = "VENDOR";

export const CONST_TAG_SCOPES = [CONST_TAG_SCOPE_VENDOR];

export const CONST_TAG_SCOPES_SELECT = [{ label: CONST_TAG_SCOPE_VENDOR, value: CONST_TAG_SCOPE_VENDOR }];
